import { HttpContextToken } from '@angular/common/http';

export const BYPASS_MSAL = new HttpContextToken(() => false);
